export const getLoading = state => {
  return state.loading;
};

export const getError = state => {
  return state.error;
};

export const getUsuario = state => {
  return state.usuario;
};

export const getUsuarioGestao = state => {
  return state.usuarioGestao;
};

export const getCaptcha = state => {
  return state.captcha;
};

export const getWsAtivo = state => {
  return state.wsAtivo;
};